module.exports = __webpack_public_path__ + "img/bb_g3_eyes-06.7cfda531.svg";